import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TEST_ID = 'icon-football';

export const FootballColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={TEST_ID}
        >
            <g id="Football" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M17.47 17.245c-7.614 7.615-15.02 3.76-15.02 3.76s-3.388-6.8 4.227-14.415c7.615-7.615 14.327-3.904 14.327-3.904s4.082 6.944-3.533 14.56z"
                    fill="#E69845"
                />
                <path
                    d="M5.927 5.928c7.267-7.268 15.464-4.386 15.81-4.26.277.102.494.32.595.596.126.346 3.007 8.543-4.26 15.81C14.069 22.078 9.782 23 6.682 23c-2.526 0-4.263-.612-4.417-.668a1.002 1.002 0 0 1-.596-.595c-.125-.346-3.008-8.544 4.259-15.81zm11.8-2.922c-2.708-.078-6.671.619-10.387 4.335-3.716 3.715-4.413 7.678-4.335 10.386.693-1.371 1.711-3.074 3.175-4.955l-.344-.345a.998.998 0 1 1 1.412-1.412l2.182 2.182a1 1 0 0 1-1.412 1.412l-.415-.415c-2.204 2.878-3.268 5.274-3.726 6.515 2.157.476 7.701 1.034 12.784-4.047 5.08-5.08 4.524-10.624 4.047-12.785-1.22.45-3.561 1.49-6.377 3.622l.44.44a.998.998 0 1 1-1.413 1.411l-2.182-2.182a.998.998 0 1 1 1.412-1.412l.32.319c1.828-1.408 3.48-2.393 4.82-3.07zM8.182 8.183a.998.998 0 0 1 1.412 0l2.182 2.182a.998.998 0 1 1-1.412 1.412L8.182 9.595a.998.998 0 0 1 0-1.412z"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
